import { REGISTER_WS, REGISTER_WS_SUCCESSFUL, REGISTER_WS_FAILED } from './actionTypes';

const initialState = {
    registrationWSError: null, messageWS: null, loadingCreateWS: false
}

const registerWS = (state = initialState, action) => {
    switch (action.type) {
        case REGISTER_WS:
            state = {
                ...state,
                loadingCreateWS: true,
                registrationWSError: null
            }
            break;
        case REGISTER_WS_SUCCESSFUL:
            state = {
                ...state,
                loadingCreateWS: false,
                messageWS: action.payload,
                registrationWSError: null
            }
            break;
        case REGISTER_WS_FAILED:
            state = {
                ...state,
                messageWS: null,
                loadingCreateWS: false,
                registrationWSError: action.payload
            }
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default registerWS;